<template>
    <div class='summary'>
        <div class="content">
            <!-- 用户结果 -->
            <div class="result">
                <div class="userInfo">
                    <div class="info">
                        <div class="resIcon">
                            <img class="img" :src="sumIcon" alt="">
                        </div>
                        <div class="text">
                            <div class="name">{{ summaryData.Name }}</div>
                            <div class="lable">姓名</div>
                        </div>
                    </div>
                    <div class="info">
                        <div class="resIcon">
                            <img class="img" :src="sumIcon2" alt="">
                        </div>
                        <div class="text">
                            <div class="name">{{ summaryData.Age }}</div>
                            <div class="lable">年龄</div>
                        </div>
                    </div>
                </div>
                <div class="infoJudge">
                    <div class="subtitle">根据你的问卷信息判断你属于：</div>
                    <div class="text">{{summaryData.Physique}}</div>
                </div>
                <div class="infoJudge">
                    <div class="subtitle">你不能吃的食物：</div>
                    <div class="text">{{summaryData.UnFood}}</div>
                </div>
            </div>

            <!-- 选择症状 -->
            <div class="symptoms">
                <div class="title">
                    <div class="icon">
                        <img class="img" :src="sumIcon3" alt="">
                    </div>
                    <div class="text">请选出你目前做想调理的一种病症?</div>
                </div>

                <van-radio-group v-model="symptomRadio">
                    <van-cell-group>
                        <van-cell :title="item.OrganTitle" clickable v-for="item in summaryData.Condition" :key="item.Id" :class="symptomRadio == item.Id ? 'checked' : ''" @click="symptomRadio = item.Id">
                            <template #right-icon>
                                <van-radio checked-color="#56D1E6" :name="item.Id" />
                            </template>
                        </van-cell>
                    </van-cell-group>
                </van-radio-group>

                <div class="btn">
                    <van-button round type="info" @click="submit">提交</van-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { CustomerFoodWayResult } from '@/api/index'
import { mapMutations } from 'vuex'
export default {
  components: {

  },
  data () {
    return {
      sumIcon: `${this.$imgDomain}/www/HealthingCore/dietIcon.png`,
      sumIcon2: `${this.$imgDomain}/www/HealthingCore/dietIcon2.png`,
      sumIcon3: `${this.$imgDomain}/www/HealthingCore/dietIcon3.png`,
      summaryData: {},
      symptomRadio: ''
    }
  },
  props: {

  },
  created () {
    if (JSON.parse(this.$query('summaryData'))) {
      this.summaryData = JSON.parse(this.$query('summaryData'))
    }
  },
  mounted () {

  },
  methods: {
    ...mapMutations(['SET_FoodData']),
    submit () {
      if (!this.symptomRadio) {
        this.$toast('请选择调理病症')
        return
      }
      const parmas = {
        id: this.summaryData.Id,
        healingId: this.symptomRadio
      }
      CustomerFoodWayResult(parmas).then(res => {
        const { data } = res
        if (data) {
          this.$toast.success('提交成功')
          this.SET_FoodData(data)
          this.$router.push({ path: '/recipes' })
        } else {
          this.$toast.fail('提交失败')
        }
      })
    }
  },
  watch: {

  },
  computed: {

  }
}
</script>
<style lang='scss' scoped>
.summary {
    height: 100vh;
    background: url('https://gotocloud8-open-sx.oss-cn-hangzhou.aliyuncs.com/www/HealthingCore/dietTyerapy3.png') no-repeat;
    background-size: 100%;
    padding: 0 15px;
    .content {
        margin-top: 180px;
        .result {
            width: 100%;
            background: #fff;
            border-radius: 10px;
            padding: 20px;
            box-shadow: 0 0 10px #EBF8F8;
            .userInfo {
                display: flex;
                justify-content: space-between;
                .info {
                    display: flex;
                    width: 45%;
                    background: #78DFDD;
                    padding: 10px 15px;
                    border-radius: 10px;
                    .resIcon{
                        width: 40px;
                        margin-right: 20px;
                    }
                    .text {
                        color: #fff;
                        font-weight: 700;
                        .name {
                            font-size: 18px;
                        }
                        .lable {
                            font-size: 16px;
                        }
                    }
                }
            }
            .infoJudge {
                width: 100%;
                padding: 10px;
                background: #F1FCFC;
                text-align: center;
                margin-top: 20px;
                font-size: 16px;
                font-weight: bold;
                .subtitle {
                    color: #999;
                }
                .text {
                    color: #78DFDD;
                    margin-top: 10px;
                    line-height: 26px;
                }
            }
        }
        .symptoms {
            margin-top: 40px;
            .title {
                display: flex;
                align-items: center;
                margin-bottom: 10px;
                .icon {
                    width: 20px;
                    height: 20px;
                }
                .text {
                    color: #333333;
                    font-size: 16px;
                    font-weight: 700;
                    margin-left: 5px;
                }
            }
            /deep/ .van-cell__title {
                color: #666666;
            }
            /deep/ .van-cell {
                padding: 5px 16px;
            }
            .checked {
                /deep/ .van-cell__title {
                    color: #56D1E6;
                }
            }
        }
        .btn {
            text-align: center;
            padding: 40px 0;
            /deep/ .van-button {
                background: linear-gradient(-58deg,#6dd6da 0%, #52cfe6 100%);
                border: none;
                width: 100%;
                .van-button__text {
                    font-size: 22px;
                    font-weight: 700;
                }
            }
        }
    }
}
</style>
